import { Constants } from '../../../../../../../constants/constants';
import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  SectionFilter,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { MatchmakerParameters } from '../../../../../../../providers/semantria-api/spote.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { FilterService } from '../../../../../../collection/services/filter.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';

export class WidgetPointSelection {
  constructor(protected filterService: FilterService) {}

  assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison,
    sectionFilter?: SectionFilter[]
  ): AiInsightPayloadParams {
    const payload: AiInsightPayloadParams = {
      properties: {},
      scene_params: {},
      buckets: [],
    };

    if (comparison) {
      payload.scene_params.comparison_field = comparison.title;
    }

    if (widget.payload.selectedSection) {
      payload.scene_params.section_property = widget.payload.selectedSection.reduce(
        (acc, section) => {
          if (section.type === 'metadata') {
            acc.section_metadata ??= {};
            acc.section_metadata[section.field] = section.buckets;
            return acc;
          }

          acc[section.field.replace(Constants.SECTION_PROPERTIES_PREFIX, '')] = section.buckets;
          return acc;
        },
        {} as any
      );
    }

    if (widget.payload.dateInterval) {
      payload.scene_params.time_interval = widget.payload.dateInterval;
    }

    for (let pointIdx = 0; pointIdx < selectedPoints.length; pointIdx++) {
      let pointGroup = selectedPoints[pointIdx];
      if (!Array.isArray(pointGroup)) {
        pointGroup = [selectedPoints[pointIdx]];
      }

      for (let comparisonIdx = 0; comparisonIdx < pointGroup.length; comparisonIdx++) {
        const point = pointGroup[comparisonIdx];
        const comparisonFilter =
          comparison?.filters[point.series?.index ?? comparisonIdx] ?? comparison?.filters[0];
        const widgetQueryOptions = this.filterService.getWidgetQueryOptions(
          widget,
          dataSource,
          widgetGroup,
          comparisonFilter
        );

        if (sectionFilter) {
          widgetQueryOptions.sectionFilter = sectionFilter;
        }

        this.fillWidgetQueryOptionsForWidget(widgetQueryOptions, widget);
        this.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

        const bucket: MatchmakerParameters = {
          analytic_item_type: FieldService.getFieldLongName(
            widget.payload.analyticItem?.replace(Constants.SECTION_PROPERTIES_PREFIX, '')
          ),
          analytic_item_value: point.pointDisplay ?? point.pointId,
          query: this.filterService.getQueryForDocuments(widgetQueryOptions),
        };

        if (widget.payload.entityTypeFilter) {
          bucket.analytic_item_type = `${widget.payload.entityTypeFilter} ${bucket.analytic_item_type}`;
        }

        if (comparisonFilter) {
          bucket.comparison_name = comparisonFilter.label;
        }

        if (widget.payload.dateInterval) {
          bucket.date = this.filterService.toMomentIsoString(point.category);
        }

        payload.buckets.push(bucket);
      }
    }

    return payload;
  }

  protected fillWidgetQueryOptionsForWidget(
    _widgetQueryOptions,
    _widget: Widget<WidgetChartOptions>
  ) {}

  protected fillWidgetQueryOptionsForPoint(widgetQueryOptions, point: any) {
    widgetQueryOptions.pointName = point.pointId;
    widgetQueryOptions.analyticItems = [
      'documents',
      'topics',
      'entities',
      'phrases',
      'themes',
      'taxonomy',
    ];
    widgetQueryOptions.widgetContextMenu = {
      name: point.pointId,
    };
  }
}
